import InnerComponent from '@Components/Purchase/PurchaseIndent/PurchaseIndentForm';
import orgContainer from '@Components/AppContainer';

const CreatePurchaseIndent = () => ((orgContainer(InnerComponent)));
export default CreatePurchaseIndent;